import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from 'shells/icon/svg/external-link-icon';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {IframeComponent} from 'shells/iframe/iframe-component';
import {Illustration} from 'shells/illustrations/illustration';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {TwoPaneModal} from 'shells/modal/two-pane-modal';
import {Body} from 'shells/typography/body';

import {analyticsClient} from '../../analytics-client';

import styles from './refer-a-friend-modal.module.css';

const REFERRAL_IFRAME_URL = 'https://nutshell7477.links.growsumo.com?iframe';
const PARTNERSTACK_URL = 'https://partnerstack.com';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function ReferAFriendModal(props: Props) {
    const [isIFrameLoading, setIsIFrameLoading] = React.useState<boolean>(true);

    // Track when the modal is opened
    React.useEffect(() => {
        if (props.isOpen) {
            analyticsClient.track(analyticsClient.EVENTS.TRACK_REFER_A_FRIEND_MODAL_VIEWED);
        }
    }, [props.isOpen]);

    // iframe slowly fades in after load, so set timeout for a second to avoid
    // no loading state and no iframe content
    const handleIFrameLoaded = () => {
        setTimeout(() => {
            setIsIFrameLoading(false);
        }, 1000);
    };

    const handleClose = () => {
        setIsIFrameLoading(true);
        props.onClose();
    };

    const leftSection = (
        <div className={styles['left-section']}>
            <Illustration src='refer-a-friend' />
        </div>
    );

    const rightSection = (
        <div className='flex align-center pad-32'>
            <StackLegacy spacing={16}>
                <Body size='xlarge' isBold={true}>
                    Your custom referral link
                </Body>
                <Body>
                    Know a business that could benefit from using Nutshell? Refer them to us and
                    earn ($$).
                    <br />
                    <Link
                        href={
                            'https://support.nutshell.com/en/articles/11173858-how-to-refer-a-customer-to-nutshell-and-earn-a-referral-bonus'
                        }
                        variant='primary'
                        newTab={true}
                    >
                        Learn more about referral bonuses
                    </Link>
                </Body>
                <Body>
                    Enter your email to get your custom referral link and start earning today!
                </Body>
                <div className={styles['referral-iframe']}>
                    <IframeComponent
                        title='Refer a friend'
                        src={REFERRAL_IFRAME_URL}
                        onLoad={handleIFrameLoaded}
                    />
                    {isIFrameLoading && (
                        <div className='absolutely-center-and-fill pt-64 mt-32'>
                            <LoadingIcon />
                        </div>
                    )}
                </div>
                <StackLegacy spacing={8}>
                    <Body>Track your clicks and affiliate income at PartnerStack</Body>
                    <Link
                        href={PARTNERSTACK_URL}
                        variant='primary'
                        icon={ExternalLinkIcon}
                        newTab={true}
                    >
                        Go to PartnerStack
                    </Link>
                </StackLegacy>
            </StackLegacy>
        </div>
    );

    return (
        <TwoPaneModal
            // @ts-expect-error
            isOpen={props.isOpen}
            onClose={handleClose}
            leftSection={leftSection}
            rightSection={rightSection}
            maxHeight={600}
        />
    );
}
